var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "maintenance-repair" },
    [
      _c("div", { staticClass: "title-en" }, [_vm._v("综合维保子单")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ]),
                _c("el-button", { on: { click: _vm.debouncedExport } }, [
                  _vm._v(_vm._s(_vm.exportButtonText))
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.tableData, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "序号",
                    width: "60",
                    align: "center"
                  }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "CreatedTime" ||
                              column.prop === "EndTime"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row[column.prop]
                                          ? _vm
                                              .$moment(scope.row[column.prop])
                                              .format("YYYY-MM-DD HH:mm:ss")
                                          : "-"
                                      )
                                    )
                                  ])
                                : column.prop === "UploadStart"
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "upload-cell",
                                      on: {
                                        click: function($event) {
                                          return _vm.showUploadDetails(
                                            scope.row.UploadStart,
                                            "上传图片开始"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: {
                                            type: "primary",
                                            underline: false
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getUploadDisplayValue(
                                                scope.row.UploadStart
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : column.prop === "UploadEnd"
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "upload-cell",
                                      on: {
                                        click: function($event) {
                                          return _vm.showUploadDetails(
                                            scope.row.UploadEnd,
                                            "上传图片结束"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-link",
                                        {
                                          attrs: {
                                            type: "primary",
                                            underline: false
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getUploadDisplayValue(
                                                scope.row.UploadEnd
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row[column.prop] || "-")
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.uploadDialogTitle,
                  visible: _vm.uploadDetailDialogVisible,
                  width: "80%"
                },
                on: {
                  "update:visible": function($event) {
                    _vm.uploadDetailDialogVisible = $event
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "upload-detail-content" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.uploadDetailList,
                          border: "",
                          stripe: ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "name",
                            label: "文件名",
                            width: "200"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-link",
                                    {
                                      attrs: {
                                        type: "primary",
                                        underline: false
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.openImage(scope.row.url)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.name))]
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "url",
                            label: "URL地址",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "url-container" },
                                    [
                                      _c("span", { staticClass: "url-text" }, [
                                        _vm._v(_vm._s(scope.row.url))
                                      ]),
                                      _c("el-button", {
                                        staticClass: "copy-btn",
                                        attrs: {
                                          size: "mini",
                                          type: "text",
                                          icon: "el-icon-document-copy",
                                          title: "复制链接"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.copyToClipboard(
                                              scope.row.url
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ])
                        }),
                        _c("el-table-column", {
                          attrs: { label: "预览", width: "150" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "el-image",
                                    {
                                      staticStyle: {
                                        width: "100px",
                                        height: "60px",
                                        cursor: "pointer"
                                      },
                                      attrs: {
                                        src: scope.row.url,
                                        "preview-src-list": [scope.row.url],
                                        fit: "cover",
                                        "preview-teleported": true
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "image-slot",
                                          attrs: { slot: "error" },
                                          slot: "error"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-picture-outline"
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "span",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.uploadDetailDialogVisible = false
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }